import React, { useEffect, useState } from "react";
import Card from "components/card";
import {
  Dialog,
  DialogHeader,
  DialogBody,
  Button,
  Spinner,
} from "@material-tailwind/react";

import { ToastContainer, toast } from "react-toastify";
import { MdAdd } from "react-icons/md";
import { HiPencilAlt } from "react-icons/hi";

import {
  getAllCompanyFeesCategoryApi,
  addCompanyFeesCategoryApi,
  updateCompanyFeesCategoryApi,
} from "api/companyFees";
import { getAllOperatorsApi } from "api/filtersData";

function CompanyFeesCategories() {
  const [listOfTcp, setListOfTcp] = useState([]);
  const [categories, setCategories] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [showEditModale, setShowEditModale] = useState(false);
  const [modaleAction, setModaleAction] = useState("new");
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [editFormValue, setEditFormValue] = useState({
    tcp: "",
    category: "",
    requiresStartEndPoint: false,
  });
  const [subCategories, setSubCategories] = useState([{ name: "" }]);

  useEffect(() => {
    getFilterData();
    getAllCompanyFeesCategory();
  }, []);

  const getFilterData = async () => {
    try {
      const response = await getAllOperatorsApi();
      setListOfTcp(response);
    } catch (err) {
      console.log(err);
    }
  };

  const getAllCompanyFeesCategory = async () => {
    try {
      setIsLoading(true);
      const response = await getAllCompanyFeesCategoryApi();
      setCategories(response);
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleShowToast = (type, message) => {
    if (type === "success") {
      toast.success(message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } else if (type === "error") {
      toast.error(message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
  };

  const handleAddModale = () => {
    try {
      setModaleAction("new");
      setSelectedCategory(null);
      setEditFormValue({ tcp: "", category: "", requiresStartEndPoint: false });
      setSubCategories([{ name: "" }]);

      setShowEditModale(!showEditModale);
    } catch (err) {
      console.log(err);
    }
  };

  const handleEditModale = (category) => {
    try {
      if (category) {
        setModaleAction("update");
        setSelectedCategory(category);
        setEditFormValue({
          tcp: category.tcp?._id || category.tcp || "",
          category: category.category,
          requiresStartEndPoint: category.requiresStartEndPoint || false,
        });
        setSubCategories(
          category.subCategories.map((el) => ({ _id: el._id, name: el.name }))
        );
      }

      setShowEditModale(!showEditModale);
    } catch (err) {
      console.log(err);
    }
  };

  const handleEditFormInputChange = (e) => {
    const { name, value } = e.target;
    setEditFormValue((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleRequiresStartEndPointChange = (e) => {
    const { checked } = e.target;
    setEditFormValue((prev) => ({
      ...prev,
      requiresStartEndPoint: checked,
    }));
  };

  const handleAddSubCategory = () => {
    setSubCategories([...subCategories, { name: "" }]);
  };

  const handleRemoveSubCategory = (index) => {
    setSubCategories(subCategories.filter((el, i) => i !== index));
  };

  const handleSubCategoryChange = (index, value) => {
    setSubCategories(
      subCategories.map((el, i) => (i === index ? { ...el, name: value } : el))
    );
  };

  const handleConfirmEditModale = async () => {
    try {
      if (!editFormValue.tcp) {
        handleShowToast("error", "Sélectionner le TCP");
        return;
      }

      if (!editFormValue.category.trim()) {
        handleShowToast("error", "Saisir la catégorie");
        return;
      }

      if (subCategories.some((el) => !el.name.trim())) {
        handleShowToast("error", "Saisir toutes les sous-catégories");
        return;
      }

      const formObjectData = {
        tcp: editFormValue.tcp,
        category: editFormValue.category.trim(),
        subCategories: subCategories.map((el) =>
          el._id
            ? { _id: el._id, name: el.name.trim() }
            : { name: el.name.trim() }
        ),
        requiresStartEndPoint: editFormValue.requiresStartEndPoint,
      };

      if (modaleAction === "new") {
        await addCompanyFeesCategoryApi(formObjectData);
      } else {
        await updateCompanyFeesCategoryApi(formObjectData, selectedCategory._id);
      }

      setShowEditModale(false);
      setSelectedCategory(null);
      setEditFormValue({ tcp: "", category: "" });
      setSubCategories([{ name: "" }]);

      getAllCompanyFeesCategory();

      handleShowToast(
        "success",
        modaleAction === "new"
          ? "Catégorie ajoutée avec succès"
          : "Catégorie modifiée avec succès"
      );
    } catch (err) {
      console.log(err);
      handleShowToast(
        "error",
        err?.response?.data?.error || "Une erreur est survenue, réessayer"
      );
    }
  };

  return (
    <Card extra={"w-full pb-10 p-4 h-full mt-5"}>
      <ToastContainer />

      <Dialog
        size="xl"
        open={showEditModale}
        handler={() => handleEditModale()}
        className="max-h-[90vh] overflow-y-auto"
      >
        <DialogHeader>
          <p className="w-full text-center">
            {modaleAction === "new"
              ? "Ajouter une catégorie"
              : "Modifier la catégorie"}
          </p>
        </DialogHeader>
        <DialogBody>
          <div className="mb-5">
            <label htmlFor="" className="text-md font-bold text-navy-700">
              TCP :
            </label>
            <select
              className={`flex w-full items-center justify-center rounded-xl border bg-white/0 p-2 text-sm outline-none`}
              name="tcp"
              value={editFormValue.tcp}
              onChange={handleEditFormInputChange}
              required
            >
              <option value=""></option>
              {listOfTcp.map((el) => (
                <option key={el._id} value={el._id}>
                  {el.Name}
                </option>
              ))}
            </select>
          </div>

          <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
            <div>
              <label htmlFor="" className="text-md font-bold text-navy-700">
                Catégorie :
              </label>
              <input
                type="text"
                placeholder=""
                className={`flex w-full items-center justify-center rounded-xl border bg-white/0 p-2 text-sm outline-none`}
                name="category"
                value={editFormValue.category}
                onChange={handleEditFormInputChange}
                required
              />
            </div>
            <div>
              <label htmlFor="" className="text-md font-bold text-navy-700">
                Sous-catégories :
              </label>
              {subCategories.map((subCategory, index) => (
                <div
                  key={subCategory._id || `new-${index}`}
                  className="mb-2 flex items-center gap-2"
                >
                  <input
                    type="text"
                    placeholder=""
                    className={`flex w-full items-center justify-center rounded-xl border bg-white/0 p-2 text-sm outline-none`}
                    name={`subCategory-${index}`}
                    value={subCategory.name}
                    onChange={(e) =>
                      handleSubCategoryChange(index, e.target.value)
                    }
                    required
                  />
                  {subCategories.length > 1 && (
                    <Button
                      variant="text"
                      color="#cf503f"
                      className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full p-0 text-red-500"
                      onClick={() => handleRemoveSubCategory(index)}
                    >
                      <span>×</span>
                    </Button>
                  )}
                </div>
              ))}
              <Button
                variant="text"
                color="green"
                className="flex items-center gap-1 rounded-full px-3 py-1 text-green-500"
                onClick={() => handleAddSubCategory()}
              >
                <MdAdd className="h-4 w-4" />
                <span>Ajouter une sous-catégorie</span>
              </Button>
            </div>
          </div>

          <div className="mt-5 flex items-center gap-2">
            <input
              type="checkbox"
              id="requiresStartEndPoint"
              className="rounded border-gray-300 text-[#236571] focus:ring-[#236571]"
              checked={editFormValue.requiresStartEndPoint}
              onChange={handleRequiresStartEndPointChange}
            />
            <label
              htmlFor="requiresStartEndPoint"
              className="text-md font-bold text-navy-700"
            >
              Nécessite un point de départ et un point d'arrivée
            </label>
          </div>

          <div className="mt-5">
            <Button
              variant="gradient"
              color="#236571"
              onClick={() => handleConfirmEditModale()}
              className="mr-1"
            >
              <span>Confirmer</span>
            </Button>
            <Button
              variant="text"
              color="#cf503f"
              onClick={() => handleEditModale()}
              className="mr-1"
            >
              <span>Annuler</span>
            </Button>
          </div>
        </DialogBody>
      </Dialog>

      <header className="relative flex flex-col items-center justify-between md:flex-row">
        <div className="mb-5 text-xl font-bold text-navy-700 dark:text-white md:mb-0">
          Catégories des frais de société
        </div>
        <Button
          variant="text"
          color="green"
          className="flex h-12 w-12 items-center justify-center rounded-full p-0 text-green-500"
          onClick={() => handleAddModale()}
        >
          <MdAdd className="h-8 w-8" />
        </Button>
      </header>

      {isLoading ? (
        <div className="mt-8 flex items-center justify-center">
          <Spinner className="h-12 w-12" />
        </div>
      ) : (
        <div className="mt-8 overflow-x-scroll">
          <table className="w-full">
            <thead>
              <tr>
                <th className="border-b border-gray-200 pr-28 pb-[10px] text-start dark:!border-navy-700">
                  <p className="text-xs tracking-wide text-gray-600">
                    Catégorie
                  </p>
                </th>
                <th className="border-b border-gray-200 pr-28 pb-[10px] text-start dark:!border-navy-700">
                  <p className="text-xs tracking-wide text-gray-600">TCP</p>
                </th>
                <th className="border-b border-gray-200 pr-28 pb-[10px] text-start dark:!border-navy-700">
                  <p className="text-xs tracking-wide text-gray-600">
                    Sous-catégories
                  </p>
                </th>
                <th className="border-b border-gray-200 pr-28 pb-[10px] text-start dark:!border-navy-700">
                  <p className="text-xs tracking-wide text-gray-600">Actions</p>
                </th>
              </tr>
            </thead>
            <tbody>
              {categories.map((el) => (
                <tr key={el._id}>
                  <td className="border-b border-gray-200 py-3 pr-4 dark:!border-navy-700">
                    <p className="text-sm font-bold text-navy-700 dark:text-white">
                      {el.category}
                    </p>
                  </td>
                  <td className="border-b border-gray-200 py-3 pr-4 dark:!border-navy-700">
                    <p className="text-sm text-navy-700 dark:text-white">
                      {el.tcp?.Name || ""}
                    </p>
                  </td>
                  <td className="border-b border-gray-200 py-3 pr-4 dark:!border-navy-700">
                    <div className="flex flex-wrap gap-2">
                      {el.subCategories.map((sub) => (
                        <span
                          key={sub._id}
                          className="rounded-full bg-gray-100 px-3 py-1 text-xs text-navy-700 dark:bg-navy-700 dark:text-white"
                        >
                          {sub.name}
                        </span>
                      ))}
                    </div>
                  </td>
                  <td className="border-b border-gray-200 py-3 pr-4 dark:!border-navy-700">
                    <Button
                      variant="text"
                      color="#236571"
                      className="flex h-8 w-8 items-center justify-center rounded-full p-0"
                      onClick={() => handleEditModale(el)}
                    >
                      <HiPencilAlt className="h-5 w-5" />
                    </Button>
                  </td>
                </tr>
              ))}
              {categories.length === 0 && (
                <tr>
                  <td colSpan={4} className="py-6 text-center">
                    <p className="text-sm text-gray-600">
                      Aucune catégorie disponible
                    </p>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </Card>
  );
}

export default CompanyFeesCategories;
